import { z } from 'zod';

import {
  EXECUTION_LOG_STATUS,
  EXECUTION_LOG_TRIGGER_SOURCE,
} from './constants';

/**
 * Shared Zod schemas for the data-subscription API. These guard the
 * (not-yet-stable) backend contract: fetchers `safeParse` responses against them
 * and log a warning on mismatch instead of throwing, so a backend field change
 * degrades gracefully rather than breaking the screen.
 *
 * Endpoint-specific schemas live in the endpoint folders and build on these.
 */

export const zodExecutionLogStatusSchema = z.enum(EXECUTION_LOG_STATUS);

export const zodExecutionLogTriggerSourceSchema = z.enum(
  EXECUTION_LOG_TRIGGER_SOURCE,
);

const zodExecutionLogDetailSchema = z.object({
  dlnId: z.uuid(),
  dlnNr: z.string(),
  response: z.string().nullable(),
  status: zodExecutionLogStatusSchema,
});

export const zodExecutionLogSchema = z.object({
  companyAccountId: z.uuid(),
  createdOn: z.string(),
  dataSubscriptionContactPointId: z.uuid(),
  details: z.array(zodExecutionLogDetailSchema),
  id: z.uuid(),
  latestVersion: z.boolean(),
  modifiedOn: z.string(),
  status: zodExecutionLogStatusSchema,
  taskId: z.uuid(),
  taskName: z.string(),
  triggeredByUserId: z.uuid().nullable(),
  triggeredByUserName: z.string().nullable(),
  triggerSource: zodExecutionLogTriggerSourceSchema.nullable(),
  version: z.number(),
});

/**
 * The contact point list as it arrives on the conversion-free client: snake_case
 * keys, and each contact point still an unconverted object. Only the envelope is
 * checked; the contact point's own fields are read through ContactPointObject.
 */
export const zodRawContactPointListSchema = z.object({
  contact_points: z.array(z.record(z.string(), z.json())).default([]),
});

/**
 * Acknowledgement returned by the async task endpoints (run contact point,
 * rerun execution log).
 */
export const zodCodeMessageResponseSchema = z.object({
  code: z.number(),
  message: z.string(),
});
